module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point01_02_travel-c44794aa9b2771a4e27770a67f54030a.jpg";